import { Dialog, DialogSurface, DialogBody, DialogActions, Button } from '@fluentui/react-components';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

interface ChangeRevertConfirmationDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ChangeRevertConfirmationDialog: React.FC<ChangeRevertConfirmationDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => { if (!data.open) onCancel(); }}>
      <DialogSurface>
        <DialogBody>
          <FormattedMessage
            defaultMessage="Are you sure you want to revert your changes?"
            description="confirmation dialog content body"
          />
          <DialogActions>
            <Button appearance="secondary" onClick={onCancel}>
              <FormattedMessage defaultMessage="Cancel" description="confirnation dialog cancel button" />
            </Button>
            <Button appearance="primary" onClick={onConfirm}>
              <FormattedMessage defaultMessage="Confirm" id="confirmation dialog confirm button" />
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};